import { ThemeDispatchTypes } from "../actions/ThemeActionsTypes";

interface DefaultStateI {
  theme: string;
}

const defaultState: DefaultStateI = {
  theme: "dark",
};

const ThemeReducer = (
  state: DefaultStateI = defaultState,
  action: ThemeDispatchTypes
): DefaultStateI => {
  switch (action.type) {
    case "CHANGE_THEME":
      if (state.theme === "light") {
        return {
          theme: "dark",
        };
      } else {
        return {
          theme: "light",
        };
      }
    default:
      return state;
  }
};

export default ThemeReducer;
